export default __webpack_public_path__ + "img/fzfSwrKq.1bf5b721.svg";